import { Grid, Stack } from "@mui/material";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import TopSection from "../../../Components/Common/Top/TopSection";
import CIMaterialConfig from "./CIMaterialConfig";
import { setActiveDataElement } from "../../../redux/userSlice";

function CICustomConfiguration() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setActiveDataElement("Concentrate Inventory"));
  }, [dispatch]);

  return (
    <>
      <Stack>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TopSection
              title="Concentrate Inventory Custom Configuration"
            />
            <div class="container">
                <CIMaterialConfig />
            </div>
          </Grid>
        </Grid>
      </Stack>
    </>
  );
}
export default CICustomConfiguration
